import React from 'react';
import styled from 'styled-components';

import { breakpoints } from 'components';

type ContentLayoutProps = {
  detailsSection: React.ReactNode;
  notificationsSection: React.ReactNode;
  permissionsSection: React.ReactNode;
  showPermission?: boolean;
};

const ContentLayout: React.FC<ContentLayoutProps> = ({
  detailsSection,
  notificationsSection,
  permissionsSection,
  showPermission = true,
}) => (
    <StyledContainer>
      <StyledDetailsSection>{detailsSection}</StyledDetailsSection>
      <StyledNotificationsSection>
        {notificationsSection}
      </StyledNotificationsSection>
      {showPermission && (
        <StyledPermissionsSection>
          {permissionsSection}
        </StyledPermissionsSection>
      )}
    </StyledContainer>
  );

export default ContentLayout;

const StyledContainer = styled.div`
  display: grid;
  grid-template-columns: 7fr 5fr;
  grid-template-rows: auto 1fr;
  column-gap: 32px;
  row-gap: 64px;

  @media (max-width: ${breakpoints.md}px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
  }
`;

const StyledDetailsSection = styled.div`
  grid-row: 1 / span 2;
`;

const StyledNotificationsSection = styled.div``;

const StyledPermissionsSection = styled.div`
  display: grid;
  gap: 16px;
`;
